import { Divider } from "@/components/shared/divider";
import { Skeleton, View } from "@/components/ui";

export const GiftCardHistorySkeleton = () => {
  return (
    <View>
      {[1, 2, 3].map((_, index) => (
        <View key={index}>
          <View className="flex flex-row items-start gap-3 p-4">
            <Skeleton className="h-6 w-6" />
            <View className="mr-auto flex flex-col gap-1">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-4 w-16" />
              <Skeleton className="h-3 w-28" />
              <Skeleton className="h-3 w-20" />
            </View>
            <Skeleton className="h-5 w-16 self-center" />
          </View>
          {index !== 2 && <Divider />}
        </View>
      ))}
    </View>
  );
};
